import { isAgentEventDataSuggestion } from "../../../models/aiAgents/sessions.eventData";
import { getUnresolvedStatusDetails, ServiceCampaignStatus } from "../../../models/campaigns/instruction";
import { DerivedLineItemStatus } from "../../../models/campaigns/lineitems";
import { ServiceStatus } from "../../../types/enums";
import { snakeToCamelCase } from "../../../utils/strings";
export const campaignIoAgentConfig = {
    async formatMessage({ sessionId, ...opts }, sdk) {
        if (opts.attachments?.length) {
            return {
                ...opts,
                // whitespace is need to not get 400 from the service when attachments are included without a message
                message: opts.message || " "
            };
        }
        // If there are no attachments, we create a text file with the message content and upload it,
        // then return the message with the attachment for the agent to process.
        const txtFile = await sdk.ai.agents["campaign-io"].uploads.save({
            sessionId,
            file: new File([opts.message], `MAVERICK-CAMP-IO-${Date.now()}-${crypto.randomUUID()}.txt`, {
                type: "text/plain"
            })
        });
        return {
            ...opts,
            attachments: [txtFile]
        };
    },
    event: {
        data: {
            fromService: campaignIoAgentEventDataFromService
        }
    }
};
/**
 * Transforms raw service campaign IO agent event data into structured agent event data.
 * used for `event.data.fromService` for the campaign-io agent.
 */
async function campaignIoAgentEventDataFromService(data, sdk) {
    if (!Array.isArray(data)) {
        return undefined;
    }
    const response = [];
    let idNum = 0;
    const statusDetails = getUnresolvedStatusDetails();
    statusDetails.canBe.edited = true;
    statusDetails.code = ServiceStatus.DRAFT;
    for await (const item of data) {
        if (isAgentEventDataSuggestion(item, "campaign")) {
            const campaign = await sdk.campaigns.toCampaign({
                ...item.data,
                id: undefined,
                parent: item.data.parent || sdk.getCurrentUser()?.parent || "",
                status: ServiceCampaignStatus.READY,
                status_details: {
                    ...statusDetails,
                    summary: ServiceCampaignStatus.READY
                }
            });
            response.push({
                ...item,
                data: campaign,
                unresolved: formatUnresolvedEventData(item.unresolved)
            });
        }
        else if (isAgentEventDataSuggestion(item, "line-item")) {
            const lineItem = await sdk.campaigns.lineItems.toLineItem({
                ...item.data,
                id: item.data.id || `line-item-${idNum++}`,
                status_details: {
                    ...statusDetails,
                    summary: DerivedLineItemStatus.READY
                }
            });
            response.push({
                ...item,
                data: lineItem,
                unresolved: formatUnresolvedEventData(item.unresolved)
            });
        }
    }
    return response;
}
function formatUnresolvedEventData(unresolved) {
    if (!unresolved?.length) {
        return undefined;
    }
    return unresolved.map((item) => {
        let key = item.key;
        // common keys agent returns, instead of the actual '_id' suffix
        if (["product", "advertiser", "publisher_group", "agency", "station"].includes(key)) {
            key = `${key}_id`;
        }
        if (/^geo_(include|exclude)/.test(item.key)) {
            key = key.replace(/^geo_/, "geo_targeting.");
        }
        if (key === "segment") {
            key = "segments";
        }
        return {
            ...item,
            key: snakeToCamelCase(key)
        };
    });
}
//# sourceMappingURL=campaign-io.config.js.map